export const projectKeys = {
  allProjects: ['all-projects'],
  project: (slug: string) => ['current-project', slug],
  validateProject: (slug: string) => ['validate-project', slug],
};

export const mutationProjectKeys = {
  scaling: ['scale-project'],
  creating: ['create-project'],
  createProject: (slug: string) => [...mutationProjectKeys.creating, slug],
  scalingProject: (slug: string) => [...mutationProjectKeys.scaling, slug],
  scalingDb: (slug: string, dbType: string) => [
    ...mutationProjectKeys.scaling,
    dbType,
    slug,
  ],
  validateProject: (slug: string) => ['validate-project-post', slug],
  stopBuild: (slug: string) => ['stop-build', slug],
};
